/**
 * Session Redux Types
 */

import { UserSession, SessionCheckResponse } from "@/types/session";

export interface ISessionState {
  activeSessions: UserSession[];
  currentSession: UserSession | null;
  sharingDetected: boolean;
  anomalies: string[];
  loading: boolean;
  error: string | null;
  lastChecked: string | null;
  isMonitoring: boolean;
}

export const initialSessionState: ISessionState = {
  activeSessions: [],
  currentSession: null,
  sharingDetected: false,
  anomalies: [],
  loading: false,
  error: null,
  lastChecked: null,
  isMonitoring: false,
};
